module.exports = __webpack_public_path__ + "static/media/BS_O_Fashion_Roseto Sand_DK Grey.aa67e762.png";